require('./bootstrap');
import Alpine from 'alpinejs'
import './mobile-menu';
import "./social-container";
import AOS from 'aos';

require('./swiper');
window.Alpine = Alpine
Alpine.start()
document.addEventListener('DOMContentLoaded', function () {

    AOS.init({
        disable: false,
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,
        offset: 100,
        delay: 0,
        duration: 1000,
        easing: 'ease',
        once: false,
        mirror: false,
        anchorPlacement: 'top-bottom',
    });
});
// harvestProgressScript.js

// harvestProgressScript.js






